import PrimaryBtn from 'components/shared/Buttons/PrimaryButton';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { MyQuotationsTable } from '../../../my-quotations/MyQuotationsTable';
import { PageTitle } from '../../../shared/Typography/PageTitle';
import { TitleWrapper } from '../Quotations/Quotations';

export const MyQuotations = () => {
    const { t } = useTranslation('quotations', {
        keyPrefix: 'MY_QUOTATIONS',
    });

    const navigate = useNavigate();

    return (
        <>
            <TitleWrapper>
                <PageTitle>{t('TITLE')}</PageTitle>

                <PrimaryBtn onClick={navigate.bind(this, '/collections/all')}>
                    {t('ADD_NEW')}
                </PrimaryBtn>
            </TitleWrapper>

            <MyQuotationsTable />
        </>
    );
};
